var e="\nvec3 cubeMapProject(vec3 dir) {\n    return cubeMapRotate(dir);\n}\n";export{e as default};
